import { supabase } from '../lib/supabase'
import type { Card } from '../types'

function toCard(row: {
  id: string; name: string; last4: string; tone: string
  bill: unknown; credit_limit: unknown; due: number; close: number; is_archived: boolean
}): Card {
  return {
    id: row.id,
    name: row.name,
    last4: row.last4,
    tone: row.tone,
    bill: Number(row.bill),
    limit: Number(row.credit_limit),
    due: Number(row.due),
    close: Number(row.close),
    is_archived: row.is_archived ?? false,
  }
}

export async function listCards(householdId: string): Promise<Card[]> {
  const { data, error } = await supabase
    .from('cards')
    .select('*')
    .eq('household_id', householdId)
    .order('created_at')

  if (error) throw error
  return (data ?? []).map(toCard)
}

export async function createCard(
  householdId: string,
  card: Omit<Card, 'id'>,
): Promise<Card> {
  const { data, error } = await supabase.from('cards').insert({
    household_id: householdId,
    name: card.name,
    last4: card.last4,
    tone: card.tone,
    bill: card.bill,
    credit_limit: card.limit,
    due: card.due,
    close: card.close,
    is_archived: card.is_archived ?? false,
  }).select('*').single()
  if (error) throw error
  return toCard(data)
}

export async function updateCard(
  id: string,
  changes: Partial<Omit<Card, 'id'>>,
): Promise<void> {
  const payload: Record<string, unknown> = {}
  if (changes.name  !== undefined) payload.name         = changes.name
  if (changes.last4 !== undefined) payload.last4        = changes.last4
  if (changes.tone  !== undefined) payload.tone         = changes.tone
  if (changes.bill  !== undefined) payload.bill         = changes.bill
  if (changes.limit !== undefined) payload.credit_limit = changes.limit
  if (changes.due   !== undefined) payload.due          = changes.due
  if (changes.close !== undefined) payload.close        = changes.close
  if (changes.is_archived !== undefined) payload.is_archived = changes.is_archived

  const { error } = await supabase.from('cards').update(payload).eq('id', id)
  if (error) throw error
}

export async function deleteCard(id: string): Promise<void> {
  const { error } = await supabase.from('cards').delete().eq('id', id)
  if (error) throw error
}
